function monthToString(monthIndex: number): string {
  const months = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ];

  if (monthIndex >= 0 && monthIndex < months.length) {
    return months[monthIndex];
  }

  return 'Неизвестный месяц';
}

export default monthToString;
